export const PaymentResponseEvent = {
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
  TIMEOUT: 'TIMEOUT',
  CANCEL: 'CANCEL'
}

export default class PaymentResponse {
  constructor ({ code, transactionId, event, merchant, orderId, startTime, invoiceId, invoiceKey }) {
    this.code = code
    this.transactionId = transactionId
    this.event = event
    this.merchant = merchant
    this.orderId = orderId
    this.startTime = startTime
    this.invoiceId = invoiceId
    this.invoiceKey = invoiceKey
  }

  isSuccessful () {
    return this.event === PaymentResponseEvent.SUCCESS
  }

  isFailed () {
    return this.event === PaymentResponseEvent.FAIL
  }

  isTimedOut () {
    return this.event === PaymentResponseEvent.TIMEOUT
  }

  isCancelled () {
    return this.event === PaymentResponseEvent.CANCEL
  }

  encode () {
    return btoa(JSON.stringify(this))
  }
}
